export default "__VITE_ASSET__BZq$E8LR__"